export type NurseTriage = {
  requisitionId: string;
  nurseProfileId: string;
  note: string;
  createdAt: string;
  noteRead: boolean;
  noteReadAt: string | null;
};

export type NurseTriageDTO = {
  requisition_id: string;
  nurse_profile_id: string;
  note: string;
  created_at: string;
  forwarded_at: string | null;
  notes_read: boolean;
  notes_read_at: string | null;
  notes_read_by_doctor_profile_id: string | null;
};

export class NurseTriageViewModelFactory {
  static createFromDTO(dto: NurseTriageDTO): NurseTriage {
    return {
      requisitionId: dto.requisition_id,
      nurseProfileId: dto.nurse_profile_id,
      note: dto.note,
      createdAt: dto.created_at,
      noteRead: dto.notes_read,
      noteReadAt: dto.notes_read_at,
    };
  }
}
